import { render, staticRenderFns } from "./SimulationBox.vue?vue&type=template&id=12bab64e"
import script from "./SimulationBox.vue?vue&type=script&lang=js"
export * from "./SimulationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports